import { render, staticRenderFns } from "./VestingPayment.vue?vue&type=template&id=246a983a"
import script from "./VestingPayment.vue?vue&type=script&lang=js"
export * from "./VestingPayment.vue?vue&type=script&lang=js"
import style0 from "./VestingPayment.vue?vue&type=style&index=0&id=246a983a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports